export enum TSAType {
  Normal,
  NoAdmin,
  NoTsa,
}
